"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyInferenceData = void 0;
exports.PropertyInferenceData = {
    buses: {
        I2C: {
            busName: "I2C",
            pins: {
                ["SDA"]: { type: "Bi-Directional" },
                ["SCL"]: { type: "Bi-Directional" },
            },
            variations: [
                // Ensure variation pin order matches the order of pins above
                ["AD", "SCL"],
                ["SDATA", "SCLK"],
            ],
        },
        SPI: {
            busName: "SPI",
            pins: {
                ["SCLK"]: { type: "Bi-Directional" },
                ["MISO"]: { type: "Bi-Directional" },
                ["MOSI"]: { type: "Bi-Directional" },
                ["CS"]: { type: "Bi-Directional" },
            },
            variations: [
                ["CLK", "POCI", "PICO", "CS"],
                ["SCK", "RX", "TX", "CS"],
                ["CLK", "SOMI", "SIMO", "SCS"],
            ],
        },
        UART: {
            busName: "UART",
            pins: {
                ["TX"]: { type: "Output" },
                ["RX"]: { type: "Input" },
            },
        },
        CAN: {
            busName: "CAN",
            // TODO should we match these as H and L? Should we not even use pin-name matching here, since the bus
            // name would actually match anyway?
            pins: {
                ["CAN_H"]: { type: "Bi-Directional" },
                ["CAN_L"]: { type: "Bi-Directional" },
            },
        },
        USBSS: {
            busName: "USBSS",
            pins: {
                ["SSTXP"]: { type: "Output" },
                ["SSTXM"]: { type: "Output" },
                ["SSRXP"]: { type: "Input" },
                ["SSRXM"]: { type: "Input" },
                ["DP"]: { type: "Bi-Directional" },
                ["DM"]: { type: "Bi-Directional" },
            },
        },
    },
    partTypes: {
        // Note: in future, we'll add more nuance here, so different pins can get different types based on part type.
        // But for now, it's basically just a list of which parts have Pin Type = Passive by default.
        ["Resistor"]: { defaultPinType: "Passive" },
        ["Ceramic Capacitor"]: { defaultPinType: "Passive" },
        ["Connector"]: { defaultPinType: "Passive" },
        ["Diode"]: { defaultPinType: "Passive" },
        ["Electrolytic Capacitor"]: { defaultPinType: "Passive" },
        ["Film Capacitor"]: { defaultPinType: "Passive" },
        ["Fixed Resistor"]: { defaultPinType: "Passive" },
        ["Ground"]: { defaultPinType: "Ground" },
        ["Inductor"]: { defaultPinType: "Passive" },
        ["LED"]: { defaultPinType: "Passive" },
        ["Memristor"]: { defaultPinType: "Passive" },
        ["Non-Polarized Capacitor"]: { defaultPinType: "Passive" },
        ["Operational Amplifier (OP-AMP)"]: { defaultPinType: "Passive" },
        ["Polarized Capacitor"]: { defaultPinType: "Passive" },
        ["Power Source"]: { defaultPinType: "Power Out" },
        ["Relay"]: { defaultPinType: "Passive" },
        ["Silicon Capacitor"]: { defaultPinType: "Passive" },
        ["Super-cap Capacitor"]: { defaultPinType: "Passive" },
        ["Switch"]: { defaultPinType: "Passive" },
        ["Transformer"]: { defaultPinType: "Passive" },
        ["Transistor"]: { defaultPinType: "Passive" },
        ["Variable Resistor"]: { defaultPinType: "Passive" },
    },
    commonPinSpecs: {
        // Note: only specify the base name of the pin, not modifiers like +/- or numbers, in general.
        // Use a regex if multiple variations are possible (see nVv example below)
        // TODO "^" isn't quite what we mean for V/V+/V-, because we also want this to match when it's a single token after
        // preceding tokens. This will only match standalone V/V+/V-. Need to think through how to represent this kind of
        // case better.
        [`^[Vv]`]: { type: "Unspecified" },
        [`^NC`]: { type: "Not Connected" },
        [`^EN`]: { type: "Digital" },
        [`[-+]?[1-9]?[0-9](\\.[0-9])?[Vv]`]: { type: "Power In", defaultSection: "Power" },
        [`[-+]?[1-9]?[0-9][Vv][0-9]`]: { type: "Power In", defaultSection: "Power" },
        [`OUT[A-Z]?`]: { type: "Output" },
        [`IN[A-Z]?`]: { type: "Input" },
        [`GND[A-Z]?`]: { type: "Ground" },
        [`VCC[A-Z]?`]: { type: "Power In", defaultSection: "Power" },
        [`VDD[A-Z]?`]: { type: "Power In", defaultSection: "Power" },
        [`DVDD[A-Z]?`]: { type: "Power In", defaultSection: "Power" },
        [`TVDD[A-Z]?`]: { type: "Power In", defaultSection: "Power" },
        [`VSS[A-Z]?`]: { type: "Power In", defaultSection: "Power" },
        [`VS`]: { type: "Power In", defaultSection: "Power" },
        [`VIN[A-Z]?`]: { type: "Input" },
        [`VOUT[A-Z]?`]: { type: "Output" },
        [`GPIO[A-Z]?`]: { type: "Bi-Directional" },
        [`RESET|RST`]: { type: "Input" },
        // "PD" is "Power Down" in the one example so far (OPA863), an input to trigger opamp powerdown.
        // But it's probably really common to mean other things. So we'll want to encode this differently
        // when we have better matching / bus inference / context from copilot.
        [`PD`]: { type: "Input" },
    },
};
//# sourceMappingURL=propertyInference.js.map